// ============================================================================
// roomData.js — egy szoba-dokumentum átalakítása a kliens szoba-objektumává
// (2026-10-06).
//
// MIÉRT KÜLÖN, TISZTA FÜGGVÉNY? A csevegő szobalistája (watchMyRooms) és a
// fejléc a szobák hierarchiáját a `parentRoomId` mezőből építi (roomTree.js).
// Ez a mező a leképezésből KIMARADT: az admin panel külön forrásból kapta a
// szobáit (ezért ott látszott a hierarchia), a csevegő szobaváltója és a
// fejléc-útvonal viszont SOHA nem kapott szülő-adatot - hiába volt kész a
// megjelenítő kód. A tesztek kézzel összeállított szoba-objektumokat adtak a
// megjelenítőnek, ezért ez nem derült ki. A leképezés mostantól külön,
// közvetlenül tesztelhető, és a tesztek az ÉLŐ útvonalat is lefedik.
// ============================================================================

import { katalogusBol } from "./forumData.js";

/**
 * @param {string} roomId
 * @param {object} data a Firestore dokumentum adatai (d.data())
 */
export function szobaDokumentumbol(roomId, data) {
  const d = data || {};
  return {
    roomId,
    name: d.name || "",
    // FONTOS, VALÓS HIBÁBÓL TANULVA: a lokalizált nevek eddig kimaradtak
    // innen, így a getRoomDisplayName soha nem talált nyelvenkénti nevet,
    // és az admin által megadott fordítások sehol nem jelentek meg.
    localizedNames: d.localizedNames && typeof d.localizedNames === "object" ? d.localizedNames : {},
    // A főszoba azonosítója (alszobánál), különben null. A szobaváltó fa-
    // sorrendje és a fejléc "Főszoba ❯" útvonala ebből épül (roomTree.js).
    parentRoomId: typeof d.parentRoomId === "string" && d.parentRoomId ? d.parentRoomId : null,
    // A testvér-szobák sorrendje (2026-10-20, v125): az admin állítja (setRoomOrder); hiányában a szoba a számozottak után áll.
    sortOrder: Number.isFinite(d.sortOrder) ? d.sortOrder : null,
    archived: d.archived === true,
    // Csak olvasható szoba (2026-10-08): a tagok csak olvasnak, csak admin írhat (a szerver kényszeríti ki).
    readOnly: d.readOnly === true,
    // Fórum (2026-10-09): fórum-módú szoba (témák), és akik némították (új témáról sem kapnak push-t).
    forum: d.forum === true,
    // Útmutató-szoba (2026-10-19, a titkár #35): csak bejárat a gyerekszobákhoz, új téma nem nyitható (a szerver kényszeríti ki); a rövid
    // leírás nyelvenként (hu/en/ja) az admin által megadott szöveg.
    guide: d.guide === true,
    // Offline olvasás (2026-10-23): az admin szobánként engedélyezi; alapértelmezés: kikapcsolva (a saját offline tár csak az engedélyezett szobákat menti).
    offlineOlvasas: d.offlineOlvasas === true,
    guideText: d.guideText && typeof d.guideText === "object" && !Array.isArray(d.guideText)
      ? Object.fromEntries(Object.entries(d.guideText).filter(([k, v]) => typeof k === "string" && typeof v === "string" && v.trim() !== ""))
      : {},
    // Címkekatalógus (2026-10-16, v77): a fórum témáinak címkéi; az admin kezeli (topicAction setCatalog).
    tagCatalog: katalogusBol(d.tagCatalog),
    mutedBy: Array.isArray(d.mutedBy) ? d.mutedBy.filter((u) => typeof u === "string") : [],
    // A tagok közt ténylegesen jelen lévő nyelvek - CSAK erre fordít
    // a szerver. Régi szobáknál (a funkció bevezetése előttről) egy
    // ideig hiányozhat: a szerver az első üzenetkor kiszámolja.
    activeLangs: Array.isArray(d.activeLangs) ? d.activeLangs : null,
    // Törlés alatt álló (vagy félbeszakadt törlésű) szoba.
    deleting: d.deleting === true,
    memberIds: Array.isArray(d.memberIds) ? d.memberIds : [],
    // Az olvasatlan-jelzéshez: mikor és kitől jött az utolsó üzenet
    // (a sendMessage írja). Régi szobánál a következő üzenetig hiányzik.
    lastMessageAt:
      d.lastMessageAt && typeof d.lastMessageAt.toMillis === "function" ? d.lastMessageAt.toMillis() : null,
    lastMessageBy: typeof d.lastMessageBy === "string" ? d.lastMessageBy : null,
  };
}
